import * as angular from 'angular';
import * as _ from 'lodash';

import SubscriptionResource from '../models/subscription-resource';
import ResourceService from './resource.service';

export default class SubscriptionService extends ResourceService<SubscriptionResource> {
  defaultFilter: object = {
    subscription_type: 'EpxReportSubscription,EpxAlarmSubscription'
  };

  constructor(private BackendService: any) {
    super(BackendService, SubscriptionResource);
  }
}

angular
  .module('ciApp.services')
  .service('SubscriptionService', ['BackendService', SubscriptionService]);



// WEBPACK FOOTER //
// ./common/services/subscription.service.ts